import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';

import * as fromUser from './state/user.reducer';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.sass']
})
export class UserComponent implements OnInit {

  constructor(private store: Store<any>) { }

  ngOnInit() {
    console.log(' >>>> UserComponent ngOnInit: ');
    this.store.pipe(select(fromUser.getCurrentUser))
    .subscribe(userCurrunt =>
      console.log(' >>>> Usuario actual: ' + userCurrunt));
  }
}
